module.exports = {"150103001":"新华西路","150103002":"中山西路","150103003":"光明路","150103004":"海拉尔西路","150103005":"环河街","150103006":"通道街","150103007":"钢铁路","150103100":"攸攸板镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150103.json
// module id = 392
// module chunks = 0